<template>
    <div ref="videoContainer" class="videoContainer" v-bind:style="videoContainerStyle">
        <div class="vidImgWrapper"> 
        <div style="width:100%;" v-if="useLazy">
        <img v-if="index > 2 && Object.keys(video.snippet.thumbnails).length > 0" :data-id="video.id" v-lazy="video.snippet.thumbnails.medium.url" :alt="video.snippet.title">
        <img v-if="index <= 2 && Object.keys(video.snippet.thumbnails).length > 0" :src="video.snippet.thumbnails.medium.url" :alt="video.snippet.title">
        </div>
        <div style="width:100%;" v-else>
            <img :src="video.snippet.thumbnails.medium.url" :alt="video.snippet.title">
        </div>
            <div class="vidImgPlayLogo">
                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><defs></defs><path fill="" class="cls-1" d="M26.32,12.26c.96,.59,1.54,1.63,1.54,2.75s-.58,2.16-1.54,2.69L7.03,29.48c-.99,.66-2.23,.69-3.25,.12-1.01-.57-1.64-1.64-1.64-2.81V3.21c0-1.16,.63-2.23,1.64-2.8,1.01-.57,2.26-.55,3.25,.06L26.32,12.26Z"/></svg>
            </div>

            <span class="durationOfVid" v-if="(typeof videoDuration.minutes != 'undefined')"><i class="fas fa-clock"></i>{{minTwoDigits(videoDuration.minutes)}}:{{minTwoDigits(videoDuration.seconds)}}</span>
        </div>
        <p class="title"><span class="play"><i class="fas fa-play"></i></span><span class="titleText">{{video.snippet.title.replace(' | Pharma Nord', '')|truncate(numberOfCharacters, '...')}}</span></p>
    </div>
</template>

<script>
import { parse, end, toSeconds, pattern } from 'iso8601-duration';
export default {
    name: 'VideoContainer',
    props:{
        index: Number,
        video: [Object],
        numberOfCharacters: {
            type: Number,
            default: 40,
            },
        // Use LazyLoading - if it causes errors, set it to false
        useLazy: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
        // Observer
        observer: null,
        width: null,
        height: null,
        // Misc variables
        videoContainerStyle: {
            //width: '240px',
            //maxWidth: '240px',
        },
        }
    },
    filters:{
        truncate: function(text, length, suffix){
            if(text.length > length){
                return text.substring(0, length) + suffix;
            }else{
                return text;
            }
        }
    },
    methods:{
        minTwoDigits(n) {
            return (n < 10 ? '0' : '') + n;
        },

    },
    computed: {
        videoDuration: function(){
            if(typeof this.video.contentDetails.duration != 'undefined' && this.video.contentDetails.duration.length != 0){
                return parse(this.video.contentDetails.duration);
            }else{
                return false;
            }
        }
    },
    mounted(){

    },
    beforeDestroy(){

    },
}
</script>

<style scoped lang="scss">
.videoContainer {
    box-shadow: 0 10px 5px -5px rgba(0, 0, 0, 0.2901960784);
    border-radius: 6px;
    height: auto;
    cursor: pointer;
    width:100%;
    margin: 0px 5px;
    transition: all 0.1s ease;
    &:hover{
        box-shadow: 0 4px 5px -2px rgba(0, 0, 0, 0.2901960784);
    }

    img[lazy=loading]{
        max-height: 130px;
        height: 135px;
    }
        &:hover{
            .vidImgPlayLogo{
                svg{
                    fill: rgba(255, 255, 255, 0.8);
                }
            }
        }
        &:hover .title{
            background: lighten(#004570, 5%);
        }
    
}
.vidImgWrapper {
    position: relative;
    user-select: none;
    display: flex;
    justify-content: center;
    align-items: center;
    .vidImgPlayLogo{
        border-radius: 100%;
        color: white;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        
        svg{
            width: 70px;
            height: 70px;
            transition: fill .2s ease;
            fill: rgba(255, 255, 255, 0.1);
        }
    }
    .vidImg{
        -webkit-user-drag: none;
        user-select: none;
    }
    .durationOfVid {
        position: absolute;
        right: 4px;
        bottom: 9px;
        background: #00000094;
        color: white;
        font-weight: bold;
        width: auto;
        padding: 4px;
        border-radius: 4px;
        .fa-clock {
            margin-right: 5px;
            color: white;
            vertical-align: middle;
            margin-left: 3px;
            margin-top: -2px;
        }
    }
    img {
        width: 100%;
        margin: 0 !important;
        border-radius: 5px;
        display: block;
    }
}
.durationOfVid {
    position: absolute;
    right: 4px;
    bottom: 5px;
    background: #00000094;
    color: white;
    font-weight: bold;
    width: auto;
    padding: 4px;
    border-radius: 4px;
    .fa-clock {
        margin-right: 5px;
        color: white;
        vertical-align: middle;
        margin-left: 3px;
        margin-top: -2px;
    }
}
.title {
    background: #004570;
    font-weight: bold;
    font-size: 13px;
    min-height: 36px;
    vertical-align: middle;
    color: white;
    height: 55px;
    margin-bottom: 0;
    margin-top: -6px;
    position: relative;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all .2s ease;
    .play {
        background: #075e94;
        padding: 9px;
        width: 40px;
        vertical-align: middle;
        position: relative;
        border-bottom-left-radius: 3px;
        text-align: center;

        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        box-sizing: border-box;
        .fa-play {
            font-size: 20px;
            display: block;
            position: relative;
            color: white;
        }
    }
    .titleText {
        display: inline-block;
        width: 95%;
        padding: 6px;
        font-size: 90%;
        vertical-align: top;
        color: white;
        padding-left: 14px;
        word-break: break-word;
        line-height: 1.3;
    }
}
@media only screen and (max-width: 350px){
    .title{
        display: none;
    }
}
</style>